import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

class MainNav extends React.Component {
  howItWorksClicked(e) {
    e.preventDefault()
    const { toggleHowItWorksOpened } = this.props

    toggleHowItWorksOpened()
  }

  render() {
    return (
      <nav className="header__nav">
        <span className="header__nav__title">
          <FormattedMessage id="app.nav.booking-button" />
        </span>
        {/* <a href="#" className="header__nav__link" onClick={this.howItWorksClicked.bind(this)}>
          <FormattedMessage id="app.nav.how-it-works" />
          <i className="icon--info"></i>
        </a> */}
      </nav>
    )
  }
}

MainNav.propTypes = {
  toggleHowItWorksOpened: PropTypes.func.isRequired,
}

export default MainNav
